import { render, staticRenderFns } from "./TeamInvitesList.vue?vue&type=template&id=6e820992"
import script from "./TeamInvitesList.vue?vue&type=script&lang=js"
export * from "./TeamInvitesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports